import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Map, Iterable } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import Grid       from '@mui/material/Grid';
import TextField  from '@mui/material/TextField';

function Number({ ...props }) {
  const [state, setState] = useState(new Map());

  const input  = state.get('input', (props.value && props.value.get('value')) || '');

  function onTextChange(e) {
    if (e.target.value.length > props.maximum) return;

    let val = e.target.value.replace(/\D+/g, '');

    setState(state.set('input', val));

    // Note: Moved out of useEffect to avoid retriggering of "save() when toggling back via "prev" button
    if (isEmpty(val) || val.length > props.maximum || val.length < props.minimum) val = ''; // Sets response as invalid in index

    props.onChange(props.name, new Map({ number: val }));
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          id="outlined-number"
          type="text"
          InputLabelProps={{ shrink: true }}
          sx={{
            width:
            '100%',
            '& input::-webkit-inner-spin-button, input::-webkit-outer-spin-button': {
              WebkitAppearance: 'none',
              margin:           0,
            },
            '& input[type=number]': {
              MozAppearance: 'textfield',
            },
          }}
          value={input}
          onChange={(e) => onTextChange(e)}
          helperText={t('eos.landing_page.text.min_max_char', { min: props.minimum, max: props.maximum })}
          error={!isEmpty(input) && (input.length < props.minimum || input.length > props.maximum)}
          data-testid="textfield-number"
        />
      </Grid>
    </Grid>
  );
}

Number.defaultProps = {
  name:     null,
  value:    null,
  onChange: null,
  minimum:  1,
  maximum:  999999,
};

// https://github.com/yannickcr/eslint-plugin-react/issues/2079#issuecomment-447358434
Number.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  minimum:  PropTypes.number,
  maximum:  PropTypes.number,
};

export default Number;
